import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const InfoList = styled.ul<{
  $noSvgStyles?: boolean;
  $columns?: number;
}>`
  max-width: 600px;
  margin-top: 1.125em;
  padding: 0;
  list-style-type: none;

  li {
    display: flex;
    align-items: flex-start;
    margin: 0;
    overflow-wrap: break-word;

    &:not(:last-child) {
      margin-bottom: 12px;
    }

    &::before {
      content: none;
    }
  }

  ${(props) =>
    props.$noSvgStyles
      ? undefined
      : `svg {
    transform: translateY(0.875em) translateY(-50%);
    flex: 0 0 auto;
    width: 24px;
    margin-right: 12px;
    vertical-align: middle;
  }`};

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    li {
      display: inline-flex;
      vertical-align: top;
      width: ${({ $columns = 2 }) => 100 / $columns}%;
      padding-right: 20px;
    }
  }
`;
